import React from "react";
import styled from "styled-components";
import { FaSearch } from "react-icons/fa";
import logoCiddec from "../magenes/LogoMexicoGente.png";

const guinda = "#611232";

export default function Header({ onConsultar }) {
  return (
    <HeaderContainer>
      <LogoArea>
        <LogoImagen src={logoCiddec} alt="CIDDEC Logo" />
        <span>CENAC</span>
      </LogoArea>

      <NavArea>
        <NavItem href="#inicio">Inicio</NavItem>
        <NavItem href="#nosotros">Nosotros</NavItem>
        <NavItem href="#proceso">Proceso</NavItem>
        <ConsultarBtn onClick={onConsultar}>
          <FaSearch /> Consultar Folio
        </ConsultarBtn>
      </NavArea>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 clamp(1rem, 5vw, 4rem); // Ajuste dinámico de espacio lateral
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-family: "Inter", sans-serif;
`;

const LogoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: ${guinda};
  font-weight: 900;
  font-size: 1.3rem;
  letter-spacing: -0.5px;
`;

const LogoImagen = styled.img`
  height: 80px; // Aumentado de 50px
  width: 80px; // Aumentado de 50px
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const NavArea = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavItem = styled.a`
  text-decoration: none;
  color: #444;
  font-size: 0.9rem;
  font-weight: 600;
  transition: color 0.3s;
  &:hover {
    color: ${guinda};
  }
`;

const ConsultarBtn = styled.button`
  background: ${guinda};
  color: white;
  border: none;
  padding: 0.7rem 1.4rem;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  transition:
    transform 0.3s,
    background 0.3s;
  box-shadow: 0 4px 15px rgba(97, 18, 50, 0.2);

  &:hover {
    background: #4a0d26;
    transform: translateY(-2px);
  }
`;
